import React, { useContext, createContext, useState, useEffect } from "react";

const Gallery = createContext({});

export const GalleryProvider = (props) => {
    const [rerender, setRerender] = useState(false);
    const [capacityAvailability, setCapacityAvailability] = useState(false);

    // For pluck delete media
    const [multiSelectCheck, setMultiSelectCheck] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");
    const [layout, setLayout] = useState("list");
    const [idsList, setIdsList] = useState([]);

    return (
        <Gallery.Provider value={{
            capacityAvailability, setCapacityAvailability,
            multiSelectCheck, setMultiSelectCheck,
            selectedItem, setSelectedItem,
            rerender, setRerender,
            idsList, setIdsList,
            layout, setLayout,
        }}>
            {props.children}
        </Gallery.Provider>
    )

}

export const useGalleryContext = () => {
    return useContext(Gallery);
}

/**
 * Scoped override for a subtree that needs different GalleryContext values
 * than the app-wide GalleryProvider (e.g. the campaign builder's
 * add-content media picker, which reuses MediaCard/FolderCard's real
 * "grid" rendering but must route selection into its OWN ids state, not
 * the real Media Gallery's `idsList`). React context providers nest, so
 * this one — rendered further down the tree — simply wins for its
 * children without touching the outer GalleryProvider or any other page.
 */
export const GalleryContextOverride = ({ value, children }) => (
    <Gallery.Provider value={value}>{children}</Gallery.Provider>
);
